import { useState, useEffect, useCallback } from 'react';
import api from '../../../../services/api';
import { t } from '../../../../utils/textUtils';

export const useProjectDetail = (projectId) => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProjectData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get(`/projects/${projectId}`);
      if (response.data) {
        setProject(response.data);
      } else {
        setError(t('DATA PROYEK TIDAK DITEMUKAN'));
      }
    } catch (err) {
      console.error('Error fetching project details:', err);
      setError(
        t('GAGAL MEMUAT DETAIL PROYEK') +
          `: ${err.message || t('SILAKAN COBA LAGI NANTI')}`
      );
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    if (projectId) fetchProjectData();
  }, [projectId, fetchProjectData]);

  const updateProjectStatus = useCallback(
    async (newStatus) => {
      const response = await api.put(`/projects/${projectId}/status`, {
        status: newStatus
      });
      if (response.data) {
        setProject((prev) => ({ ...prev, status: newStatus }));
        return true;
      }
      return false;
    },
    [projectId]
  );

  return {
    project,
    loading,
    error,
    refetch: fetchProjectData,
    setProject,
    updateProjectStatus
  };
};
